import { SVGProps, Ref, forwardRef } from 'react';

export const ExclamationTriangleOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.082 6.015 3.413 17.927c-.772 1.378-1.245 2.233-1.485 2.865q-.058.156-.087.255.101.024.265.05c.668.099 1.646.104 3.225.104h13.338c1.579 0 2.557-.005 3.224-.104q.165-.026.266-.05a3 3 0 0 0-.087-.255c-.24-.632-.713-1.487-1.485-2.865l-6.67-11.912c-.8-1.431-1.305-2.322-1.736-2.88A4 4 0 0 0 12 2.916a4 4 0 0 0-.18.217c-.432.559-.936 1.45-1.738 2.881m-1.569-.879L1.844 17.047C.36 19.697-.382 21.023.197 22.012S2.294 23 5.33 23h13.338c3.037 0 4.555 0 5.134-.988.58-.989-.163-2.314-1.647-4.965l-6.67-11.91C13.944 2.378 13.172 1 12 1s-1.943 1.379-3.487 4.136M11.1 15.4V7.9h1.8v7.5zm.9 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ExclamationTriangleOutlinedSize24Glyph.displayName = 'ExclamationTriangleOutlinedSize24Glyph';
